import { redirect, type LoaderFunctionArgs, type MetaFunction } from "@remix-run/node";
import { useOutletContext } from "@remix-run/react";
import LandingPageApp from "~/ui-apps/landing-page-app/App";
import { POST_AUTH_LANDING_PATH } from "~/utilities/postAuthLanding";
import { getCachedAuthData } from "~/utilities/secured-route.server";

export const meta: MetaFunction = () => {
    return [
        { title: "MarketDataFyi: Built for long term stock market investors." },
        { name: "description", content: "Welcome to MarketDataFyi" },
    ];
};

export async function loader({ request }: LoaderFunctionArgs) {
    const authData = await getCachedAuthData(request);
    if (authData.isAuthenticated) {
        return redirect(POST_AUTH_LANDING_PATH);
    }
    return Response.json(null);
}

export default function Index() {
    const { auth } = useOutletContext<{
        auth: { isAuthenticated: boolean, user: any, displayPricingModal: boolean, isBeta: boolean },
    }>();

    return (
        <LandingPageApp isAuthenticated={auth.isAuthenticated} user={auth.user} />
    );
}